import { render, staticRenderFns } from "./surveyseller-popup.vue?vue&type=template&id=acd5b3ac&scoped=true&"
import script from "./surveyseller-popup.vue?vue&type=script&lang=js&"
export * from "./surveyseller-popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acd5b3ac",
  null
  
)

export default component.exports